import { render, staticRenderFns } from "./CardTemplate.vue?vue&type=template&id=13e79f59&scoped=true"
import script from "./CardTemplate.vue?vue&type=script&lang=js"
export * from "./CardTemplate.vue?vue&type=script&lang=js"
import style0 from "./CardTemplate.vue?vue&type=style&index=0&id=13e79f59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e79f59",
  null
  
)

export default component.exports